var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82547 21.75H17.1745C18.1027 21.75 18.8409 20.9864 18.7411 20.1066C18.0966 14.4375 14.25 14.5313 14.25 12C14.25 9.46875 18.1458 9.60938 18.7406 3.89344C18.8344 3.01312 18.1027 2.25 17.1745 2.25H6.82547C5.89734 2.25 5.1675 3.01312 5.25937 3.89344C5.85422 9.60938 9.75 9.42188 9.75 12C9.75 14.5781 5.90343 14.4375 5.25937 20.1066C5.15906 20.9864 5.89734 21.75 6.82547 21.75Z",
    stroke: "#FFB74B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0922 20.25H7.92796C7.19671 20.25 6.99046 19.4062 7.50328 18.8831C8.74453 17.625 11.25 16.7241 11.25 15.2812V10.5C11.25 9.56953 9.46875 8.85938 8.36671 7.35C8.18484 7.10109 8.20312 6.75 8.66531 6.75H15.3558C15.75 6.75 15.8353 7.09828 15.6558 7.34766C14.5697 8.85938 12.75 9.56484 12.75 10.5V15.2812C12.75 16.7123 15.3614 17.4844 16.5187 18.8845C16.9852 19.4489 16.822 20.25 16.0922 20.25Z",
    fill: "#FFB74B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingNotification);
export default __webpack_public_path__ + "static/media/pending-notification.95a15d1ffc82172463064bc2bacf08ad.svg";
export { ForwardRef as ReactComponent };